module.exports = __webpack_public_path__ + "img/fronius.1349ab5a.svg";